import axios from "axios"
import generateCorrelationId from "./generateCorrelationId"
import getCurrentDatetime from "./getCurrentDatetime"

export default function axiosPut({
  url,
  data,
  headers,
  callback,
  errorCallback,
}) {
  axios
    .put(url, data, {
      headers: {
        ...headers,
        "X-Transmission-Date-Time": getCurrentDatetime(),
        "X-Correlation-Id": generateCorrelationId(),
      },
    })
    .then((res) => {
      if (res.data.statusCode === 200) {
        callback(res.data)
      } else {
        errorCallback(res.data)
      }
    })
    .catch((err) => {
      errorCallback(err)
    })
}
